import Increase from "../../assets/illustration/increase.svg";
import Methods from "../../assets/illustration/methods.svg";
import Low from "../../assets/illustration/low.svg";
import Reports from "../../assets/illustration/reports.svg";
import Customer from "../../assets/illustration/customer-service.svg";
import FeaturesCard from "./component/FeaturesCard";

const FeaturesPage = () => {
  return (
    <div className="pt-20">
      {/*  */}
      <div className="container mx-auto px-4 md:px-11 pb-10 flex flex-col items-center gap-5">
        <div className="md:w-[70%] flex flex-col gap-5">
          <h1 className="main font-bold text-6xl text-center">
            <span className="text-primary">Tourampfood - </span>Food & Ride
            Ordering Software's main features
          </h1>
          <h3 className="sub text-base font-normal text-center">
            Tourampfood is the only solution that serves as both a food ordering
            site and a white label food ordering system for restaurant
            operators. We think that by providing the finest solution to
            hospitality industry owners, they will be able to take control of
            their companies.
          </h3>
        </div>
        <div className="bg-blue h-[400px] w-full"></div>
      </div>
      {/*  */}
      <div className="bg-[#002F38]">
        <div className="container mx-auto px-4 md:px-11 py-16 pb-10 flex flex-col items-center gap-5">
          <div className="md:w-[60%] flex flex-col gap-4 items-center md:items-start">
            <div className="flex flex-col gap-4 items-center md:items-start">
              <h1 className="main font-bold text-3xl md:text-4xl text-white text-center">
                Ordering for Takeout
              </h1>
              <h2 className="sub text-sm text-white leading-8 text-start">
                Takeout is a win-win situation for both Establishment owners and
                customers. Establishment owners get paid in advance, which saves
                them time by eliminating the need to accept manual orders over
                the phone, which may lead to mistakes and misunderstanding.
                Customers are not required to wait for the Establishment to pick
                up the phone or to inquire about the pickup time. They only need
                to browse to the website, look at the menu, and make an order
                for the time they want to pick up their food. This technology
                has helped Establishment operators improve their revenues by
                ensuring that no orders are missed even when the phone is busy
                during peak hours.
              </h2>
            </div>
            <div className="flex flex-col gap-4 items-center md:items-start">
              <h1 className="main font-bold text-3xl md:text-4xl text-white text-center">
                Pre-Orders
              </h1>
              <h2 className="sub text-sm text-white leading-8 text-start">
                Many clients prefer to prepare and organize their meals. Most of
                these consumers arrange beforehand. The Tourampfood pre-order
                feature enables consumers to place purchases in advance for days
                or weeks. This function is useful for proprietors of a
                Establishment to know what they require for that date.
              </h2>
            </div>{" "}
            <div className="flex flex-col gap-4 items-center md:items-start">
              <h1 className="main font-bold text-3xl md:text-4xl text-white text-center">
                Offers Real Time
              </h1>
              <h2 className="sub text-sm text-white leading-8 text-start ">
                There are hundreds of Web sites and meal ordering systems, but
                there's a tool that allows consumers to enter your business.
                Tourampfood real-time offers a system that allows you to take
                your clients during peak hours on a limited period and quantity
                of food. You may therefore enhance sales and purchase additional
                consumers.
              </h2>
            </div>{" "}
            <div className="flex flex-col gap-4 items-center md:items-start">
              <h1 className="main font-bold text-3xl md:text-4xl text-white text-center">
                Connect with Customers
              </h1>
              <h2 className="sub text-sm text-white leading-8 text-start">
                With our service, you may contact directly without an
                intermediate person to your consumers. You may therefore provide
                your clients with the appropriate and finest information and
                create your own trusted customer base.
              </h2>
            </div>
            <div className="flex flex-col gap-4 items-center md:items-start">
              <h1 className="main font-bold text-3xl md:text-4xl text-white">
                Instant Payments
              </h1>
              <h2 className="sub text-sm text-white leading-8 md:text-start ">
                Are you tired of waiting weeks for payment from a third-party
                delivery portal? TourampFood's payment gateway integration
                functionality allows you to receive immediate payment from your
                clients, preventing spam and unwanted orders. <br />
                <ol className="list-disc pl-4">
                  <li>Smoother Payment with more Accountability</li>
                  <li> No Extra Charges to Bank</li>
                  <li>Get Paid Directly to Your Account (Merchant Account)</li>
                </ol>
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 md:px-11 pb-10 flex flex-col py-10 items-center gap-8">
        <h1 className="font-semibold text-3xl md:text-4xl text-center">
          More features that distinguish TourampFood from other online food
          ordering services…
        </h1>
        <div className="md:w-[65%]">
          <div className="grid grid-cols-1 gap-7">
            <FeaturesCard
              head="Increase the amount of business"
              icon={Increase}
              iconBg="#7AC1DD1A"
              text="Increase your business's potential by exposing yourself to more hungry customers."
              list={[
                "Free Listing for Your Establishment",
                "Obtain a Unique URL",
                "Increase your visibility among foodies",
              ]}
            />
            <FeaturesCard
              head="Low-cost and simple to use"
              icon={Low}
              iconBg="#2DD62D1A"
              text="With Touramp Food, starting a restaurant business online is simple. You will be ready to begin in just a few minutes."
              list={[
                "Setup is quick and simple.",
                " In a matter of minutes, you'll be able to place an order.",
                " There is no need for technical knowledge.",
                " Simple Pricing",
              ]}
            />{" "}
            <FeaturesCard
              head="Methods of Delivery"
              icon={Methods}
              iconBg="#93573D1A"
              text="Establishment Owners and Users may choose from a variety of delivery methods with Touramp Food. Customers can pick from any of the delivery methods available to them, and restaurant owners can supply any of them.
             "
              list={["Delivery", "Take Away/Pick Up"]}
            />{" "}
            <FeaturesCard
              head="Reports & Analytics"
              icon={Reports}
              iconBg="#2653BE1A"
              text="TourampFood also offers the option of receiving various reports."
              list={[
                " Keep an eye on your sales.",
                " Revenue generation for certain sectors, as well as ordering patterns",
                " Predictive Analysis Reports and Graphs are used to manage future sales and improve the worth of the company.",
              ]}
            />
            <FeaturesCard
              head="Customer Service"
              icon={Customer}
              iconBg="#D4145A1A"
              text="Our support team handles all customer concerns, complaints, inquiries, and technical difficulties. Contact our support team 24 hours a day, 7 days a week, and we'll keep an eye on things for you."
              list={[
                " Mailing Lists",
                "Newsletters",
                " The Internet and Social Media",
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturesPage;
